/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Step_ApproveInputs */

const en_directory_agents_step_approve = /** @type {(inputs: Directory_Agents_Step_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens the authorization URL, reviews the requested permissions, and approves — the only human step.`)
};

const zh_directory_agents_step_approve = /** @type {(inputs: Directory_Agents_Step_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开授权链接，确认申请的权限并批准——唯一需要人参与的步骤。`)
};

/**
* | output |
* | --- |
* | "Opens the authorization URL, reviews the requested permissions, and approves — the only human step." |
*
* @param {Directory_Agents_Step_ApproveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_step_approve = /** @type {((inputs?: Directory_Agents_Step_ApproveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Step_ApproveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_step_approve(inputs)
	return zh_directory_agents_step_approve(inputs)
});
export { directory_agents_step_approve as "directory.agents.step_approve" }